'use strict';

exports.__esModule = true;
exports.PopularSpecialistSearches = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _defaultMessages = require('../lang/default-messages');

var _defaultMessages2 = _interopRequireDefault(_defaultMessages);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopularSpecialistSearches = exports.PopularSpecialistSearches = function PopularSpecialistSearches(props) {
	return _react2.default.createElement(
		'section',
		{ className: _style.moduleBlock + ' ' + _style.popularSpecialties + ' ' + _style.bgLight + ' ' + _style.bgCover + ' ' + props.className },
		_react2.default.createElement(
			'div',
			{ className: 'container' },
			_react2.default.createElement(
				'h2',
				null,
				_react2.default.createElement(_reactIntl.FormattedMessage, _defaultMessages2.default.POPULAR_SPECIALIST_SEARCHES)
			),
			_react2.default.createElement(
				'div',
				{ className: 'row' },
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-4' + ' ' + 'col-md-2' },
					_react2.default.createElement('div', { className: _style.acupuncture + ' ' + _style.icon }),
					_react2.default.createElement(
						'ul',
						null,
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Acupuncture' },
								'Acupuncture'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Audiology' },
								'Audiology'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Breast%20Surgery' },
								'Breast Surgery'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Cardiology' },
								'Cardiology'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Cardiothoracic%20Surgery' },
								'Cardiothoracic Surgery'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Chiropractic' },
								'Chiropractic'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Clinical%20Genetics' },
								'Clinical Genetics'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Cosmetic%20Medicine' },
								'Cosmetic Medicine'
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-4' + ' ' + 'col-md-2' },
					_react2.default.createElement('div', { className: _style.cardiologist + ' ' + _style.icon }),
					_react2.default.createElement(
						'ul',
						null,
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Dermatology' },
								'Dermatology'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Dietetics' },
								'Dietetics'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Endocrinology' },
								'Endocrinology'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Ear%20nose%20%26%20throat%20Surgery' },
								'ENT Surgery'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Fertility%20Medicine' },
								'Fertility Medicine'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Gastroenterology' },
								'Gastroenterology'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/General%20Practice' },
								'General Practice'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/General%20Surgery' },
								'General Surgeon'
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-4' + ' ' + 'col-md-2' },
					_react2.default.createElement('div', { className: _style.dietician + ' ' + _style.icon }),
					_react2.default.createElement(
						'ul',
						null,
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Geriatric%20Medicine' },
								'Geriatric Doctor'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Holistic%20Therapy' },
								'Holistic Therapy'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Homeopathy' },
								'Homeopathy'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Imaging%20%28Scans%29' },
								'Imaging (Scans)'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Nephrology%20%28Renal%20Medicine%29' },
								'Nephrology (Renal Medicine)'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Neurology' },
								'Neurology'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Neurosurgery' },
								'Neurosurgery'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Nutrition' },
								'Nutrition'
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-4' + ' ' + 'col-md-2' },
					_react2.default.createElement('div', { className: _style.homeopathicMedicine + ' ' + _style.icon }),
					_react2.default.createElement(
						'ul',
						null,
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Obstetrics%20%26%20Gynaecology' },
								'Obstetrics & Gynaecology'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Oncology' },
								'Oncology'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Ophthalmology' },
								'Ophthalmology'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Oral%20%26%20Maxillofacial%20Surgery' },
								'Oral & Maxillofacial Surgery'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Orthopaedic%20Surgery' },
								'Orthopaedic Surgery'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Osteopathy' },
								'Osteopathy'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Paediatric%20Surgery' },
								'Paediatric Surgery'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Paediatrics' },
								'Paediatrics'
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-4' + ' ' + 'col-md-2' },
					_react2.default.createElement('div', { className: _style.neurologist + ' ' + _style.icon }),
					_react2.default.createElement(
						'ul',
						null,
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Pain%20Management' },
								'Pain Management'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Physiotherapy' },
								'Physiotherapy'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Plastic%20Surgery' },
								'Plastic Surgery'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Podiatry' },
								'Podiatry'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Psychiatry' },
								'Psychiatry'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Psychology' },
								'Psychology'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Respiratory%20Medicine' },
								'Respiratory Medicine'
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-4' + ' ' + 'col-md-2' },
					_react2.default.createElement('div', { className: _style.nephrologist + ' ' + _style.icon }),
					_react2.default.createElement(
						'ul',
						null,
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Rheumatology' },
								'Rheumatology'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Sport%20%26%20Exercise%20Medicine%20Doctor' },
								'Sport & Exercise Medicine Doctor'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Traditional%20Chinese%20Medicine' },
								'Traditional Chinese Medicine'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Urology' },
								'Urology'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Vascular%20Surgery' },
								'Vascular Surgery'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '/London/Weight%20Loss%20%26%20Bariatric%20Surgery' },
								'Weight Loss & Bariatric Surgery'
							)
						)
					)
				)
			)
		)
	);
};

PopularSpecialistSearches.propTypes = {
	className: require('react').PropTypes.string.isRequired
};
exports.default = PopularSpecialistSearches;


// WEBPACK FOOTER //
// ./components/popular-specialist-searches/lib/components/popular-specialist-searches.js